import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';
import { useCollect, useRequest } from 'hooks';

import Show from 'components/Show';
import Nothing from 'components/Misc/Nothing';
import Unsaved from 'components/Misc/Unsaved';
import { Button } from 'components/Misc/Form';
import Progress from 'components/Misc/Progress';

import Grade from 'containers/Administrator/Users/Profile/Student/Payments/Grade';
import Incoming from 'containers/Administrator/Users/Profile/Student/Payments/Incoming';

import { useStudentPaymentStore } from 'store/user/useStudentPaymentStore';

const Payments = ({ tab, setTab }) => {
	// Cache current object's id
	const { id } = useParams();

	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Use student's payment store
	const [edited, grades, payments, onInit] = useStudentPaymentStore(state => [
		state.edited,
		state.grades,
		state.payments,
		state.onInit
	]);

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[grades.program, payments]'
	}), []);

	// Store requested user
	const [[result, progress], collect] = useCollect(`users/${id}`, parameters);

	// Store put request
	const [[updating], update] = useRequest('put', `users/${id}`);

	// Collect user on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Initialize user's data after collection
	useEffect(() => {
		if (result) onInit(result);
	}, [result]);

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async (event) => {
		event.preventDefault();

		// Do not submit if request in progress
		if (updating) return;

		// Create formdata's instance
		const data = new FormData();

		// Append all plain text data as stringified object
		data.append('data', JSON.stringify(payments));

		// Try to update material
		const [success, error] = await update(data, { related: 'student:payments' });

		// TODO: Think of a better way of handling success
		if (success) return console.log(success);

		// TODO: Thin of a better way of handling errors
		if (error) return console.log(error.message);
	};

	return (
		<div className="mt-4 p-4 space-y-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors">
			{/* Show loading progress */}
			<Progress progress={!grades?.length && progress} />

			{/* Show nothing found */}
			<Nothing visible={!grades?.length && !progress} />

			{/* Icoming payment addition */}
			<Incoming />

			{/* Show collection if results collected */}
			<Show if={grades?.length}>
				<div className="flex flex-col space-y-4">
					{grades?.map(grade =>
						<Grade key={grade.id} grade={grade} />
					)}
				</div>
			</Show>

			{/* Show controls if not progress */}
			<div className="flex justify-end">
				<Button
					icon="done"
					theme="success"
					value="Saglabāt"
					progress={updating}
					onClick={onSubmit}
				/>
			</div>

			{/* Show confirm on leave */}
			<Unsaved enabled={edited} />
		</div>
	);
};

export default Payments;